const img = require('./DoubleDoor.svg'); export default img;